import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import {
    addEmailToContactList,
    addFaxToContactList,
    addTelToContactList,
    addMobileToContactList,
    addVcardToContactList,
} from '../../helpers/typed-helpers';
import { ContactListItem, Employee } from '../../types/all-types';
import NoPortraitAvailableFemale from './no-portrait-available--female.gif';
import NoPortraitAvailableMale from './no-portrait-available--male.gif';
import * as styles from './styles.module.sass';

interface Props {
    employee: Employee;
}

const EmployeeCard = ({ employee }: Props) => {
    let contactList: ContactListItem[] = [];
    contactList = addTelToContactList(contactList, employee);
    contactList = addFaxToContactList(contactList, employee);
    contactList = addMobileToContactList(contactList, employee);
    contactList = addEmailToContactList(contactList, employee);
    contactList = addVcardToContactList(contactList, employee);

    return (
        <div className={styles.container}>
            <div className={styles.imagePart}>
                {employee.portraitImage ? (
                    <GatsbyImage
                        alt={employee.portraitImage.title}
                        image={employee.portraitImage.gatsbyImageData}
                    ></GatsbyImage>
                ) : (
                    <img
                        src={
                            employee.isMale
                                ? NoPortraitAvailableMale
                                : NoPortraitAvailableFemale
                        }
                        alt="Porträt Bild nicht vorhanden"
                    />
                )}
            </div>

            <div>
                <h2 className={styles.name}>
                    {employee.firstName} {employee.lastName}
                </h2>

                <strong className={styles.subline}>{employee.subline}</strong>

                {employee.list && (
                    <ul className={styles.dutyList}>
                        {employee.list.split(', ').map((listItem, index) => (
                            <li key={index}>{listItem}</li>
                        ))}
                    </ul>
                )}

                {contactList.length > 0 && (
                    <ul className={styles.contactList}>
                        {contactList.map((item, index) => (
                            <li key={index}>
                                {item.label && (
                                    <span
                                        className={styles.contactListItemLabel}
                                    >
                                        {item.label}
                                    </span>
                                )}
                                {item.content}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default EmployeeCard;
